const data = {
  state: {
    iconsMap: []
  },
  generate (iconsMap) {
    this.state.iconsMap = iconsMap
  }
}

export default data



// WEBPACK FOOTER //
// ./src/views/svg-icons/generateIconsView.js